import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Alert, Table, Badge } from 'react-bootstrap';
import { getRimborsiPerCliente, decisioneRimborsiOrdine } from '../services/api';

const formatData = (d) => (d ? new Date(d).toLocaleDateString('it-IT') : '-');

// Mostra i rimborsi precedenti del cliente di un ordine e, se l'ordine e' ancora da valutare,
// permette di evaderlo o rifiutarlo (Annullato: stock che rientra, rifiuto su Mirakl se in attesa di accettazione).
function RimborsiClienteModal({ ordine, onClose, onDecided }) {
  const [rimborsi, setRimborsi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ordine?.cliente_id) return;
    setRimborsi([]);
    setError(null);
    setLoading(true);
    getRimborsiPerCliente(ordine.cliente_id)
      .then((res) => setRimborsi(res.data))
      .catch((err) => setError(err.response?.data?.detail || 'Errore nel caricamento dei rimborsi del cliente.'))
      .finally(() => setLoading(false));
  }, [ordine]);

  const decidi = async (decisione) => {
    if (decisione === 'rifiuta' && !window.confirm(`Rifiutare l'ordine #${ordine.id}? Verrà annullato e lo stock rientra a magazzino.`)) return;
    setSaving(true);
    setError(null);
    try {
      const res = await decisioneRimborsiOrdine(ordine.id, decisione);
      if (res.data?.warning) alert(res.data.warning);
      onDecided();
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante il salvataggio della decisione.');
    } finally {
      setSaving(false);
    }
  };

  const daValutare = !!ordine?.rimborsi_da_valutare;

  return (
    <Modal show={!!ordine} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Rimborsi precedenti del cliente - ordine #{ordine?.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="text-center"><Spinner animation="border" /></div>}
        {error && <Alert variant="danger">{error}</Alert>}
        {!loading && rimborsi.length === 0 && !error && <p className="text-muted">Nessun ordine rimborsato per questo cliente.</p>}
        {rimborsi.length > 0 && (
          <Table size="sm" bordered className="mb-0">
            <thead>
              <tr><th>Ordine</th><th>Data ordine</th><th>Rimborsato il</th><th className="text-end">Importo</th><th>Motivo</th></tr>
            </thead>
            <tbody>
              {rimborsi.map((r) => (
                <tr key={r.id}>
                  <td>#{r.id}{r.numero_ordine_marketplace ? <small className="text-muted d-block">{r.numero_ordine_marketplace}</small> : null}</td>
                  <td>{formatData(r.data_ordine)}</td>
                  <td>{formatData(r.data_rimborso)}</td>
                  <td className="text-end">€ {Number(r.totale_ordine || 0).toFixed(2)}</td>
                  <td>
                    {r.motivo_rimborso ? <Badge bg="secondary">{r.motivo_rimborso}</Badge> : <span className="text-muted">Non indicato</span>}
                    {r.note_rimborso && <small className="text-muted d-block">{r.note_rimborso}</small>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {ordine?.decisione_rimborsi && (
          <Alert variant="info" className="mt-3 mb-0 py-2">
            Decisione presa: <strong>{ordine.decisione_rimborsi}</strong>
            {ordine.decisione_rimborsi_at ? ` il ${new Date(ordine.decisione_rimborsi_at).toLocaleString('it-IT')}` : ''}
            {ordine.decisione_rimborsi_da ? ` (${ordine.decisione_rimborsi_da})` : ''}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>Chiudi</Button>
        {daValutare && (
          <>
            <Button variant="danger" onClick={() => decidi('rifiuta')} disabled={saving}>Rifiuta ordine</Button>
            <Button variant="success" onClick={() => decidi('evadi')} disabled={saving}>
              {saving ? <Spinner as="span" animation="border" size="sm" /> : 'Evadi ordine'}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default RimborsiClienteModal;
